export default __webpack_public_path__ + "static/media/ourclient3.21a008cb.png";